import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-view-destination-content',
  templateUrl: './view-destination-content.component.html',
  styleUrls: ['./view-destination-content.component.scss']
})
export class ViewDestinationContentComponent implements OnInit {
  @Input() itinerary?: any;
  @Input() day?: any;
  selectedDestination: any = [];

  constructor(
    private translocoService: TranslocoService
  ) {
  }

  ngOnInit(): void {
    if (!this.itinerary.tour.isDatesOptional) {
      this.selectedDestination = this.itinerary.days.filter((tempDay: any) => tempDay?.destination?._id === this.day?.destination?._id)
        .map((tempDay: any) => tempDay.date);
    }else {
      this.selectedDestination = this.itinerary.days
        .map((tempDay: any, index: number) =>
          tempDay?.destination?._id === this.day?.destination?._id
            ? index   // keep index if match
            : -1      // mark as not matching
        )
        .filter((i: number) => i !== -1);
    }
  }

  displayTitle(titles: any, defaultLanguage: string): string {
    return titles
      .filter((item: any) => item.language === defaultLanguage)
      .map((item: any) => item.name);
  }

  getSelectedDayLabel(date: any): string {
    return !this.itinerary.tour.isDatesOptional
      ? date
      : this.translocoService.translate('itineraries.viewContentModal.common.dayLabel', { day: date + 1 });
  }

}
